'use strict';

var ElementTools = require('../lib/core/ElementTools.js');
var Debouncer = require('../lib/Debouncer.js');
var Viewport = require('../lib/Viewport.js');
var EventListenerOption = require('../lib/EventListenerOption.js');

var IS_OPEN_CLASS_NAME = 'isFullMenuOpen';
var IS_LOADED_CLASS_NAME = 'isLoaded';


/**
 * @class
 * @classdesc 
 */
function Menu() {
	var self = this;
	
	this._container = document.querySelector('.fullMenu');
	this._fullMenuControlElem = document.querySelector('.fullMenuControl');
	
	this._fullMenuControlElem.addEventListener('click', function(event){
		event.preventDefault();
		self.toggle();
	}, false);
	
	this._positionFullMenuControl = this._positionFullMenuControl.bind(this);
	this._debouncedPositionControl = new Debouncer(this._positionFullMenuControl).run;
	this._debouncedPositionControl();
	window.addEventListener('resize', this._debouncedPositionControl, false);
	
	this._onKeyDown = this._onKeyDown.bind(this); 
	this._onTouchStart = this._onTouchStart.bind(this); 
	this._onTouchMove = this._onTouchMove.bind(this); 
	this._onTouchEnd = this._onTouchEnd.bind(this); 
	this._onClick = this._onClick.bind(this); 
	this._onWheel = this._onWheel.bind(this);

	document.querySelector('.mainMenu').classList.add(IS_LOADED_CLASS_NAME);
	this._fullMenuControlElem.classList.add(IS_LOADED_CLASS_NAME);
}


/**
 * @private
 */
Menu.prototype._onKeyDown = function(event) {
	if (event.defaultPrevented) {
		return; // Should do nothing if the key event was already consumed.
	}
	if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
		this.close();
		event.preventDefault(); // Cancel the default action to avoid it being handled twice
	}
}


/**
 * @private
 */
Menu.prototype._onTouchStart = function(event) {
	this._isTouchActive = true;
}

/**
 * @private
 */
Menu.prototype._onTouchMove = function(event) {
	/* TODO
	This was causing issues for safari on tablets. Probably other tablets too.
	Issue is that you can't scroll in the menu, and can't always click menu items because the click gets preventDefault called on it sometimes.
	Possible solution (probably need a combination of these):
		* Only cancel if there is an actual move -- otherwise clicks seem to get blocked on some devices.. needs testing.
		* Only cancel when the menu's scroll area has hit it's max scroll. Maybe similar to the _onWheel method below.
		* Maybe something with event.target === this._container but may not be needed.
	
	if (this._isTouchActive === true) {
		event.preventDefault();
	}
	 */
}

/**
 * @private
 */
Menu.prototype._onTouchEnd = function(event) {
	this._isTouchActive = false;
}


/**
 * @private
 * Close the menu if the click is directly on the container but not on the body of it.
 */
Menu.prototype._onClick = function(event) {
	if (event.target === this._container) {
		this.close();
	}
}


/**
 * @private
 */
Menu.prototype._onWheel = function(event) {
	// Stop Y scrolling from overflowing
	if (
		this._container.scrollHeight <= this._container.clientHeight
		|| (event.deltaY < 0 && this._container.scrollTop <= 0)
		|| (event.deltaY > 0 && this._container.scrollTop >= this._container.scrollHeight - this._container.clientHeight)
	) {
		event.preventDefault();
	}
}


/**
 * @private
 */
Menu.prototype._positionFullMenuControl = function() {
	var mainMenuUl = document.querySelector('.mainMenu > ul');
	var controlTop;
	if (mainMenuUl.offsetHeight !== 0) {
		var mainMenuTop = mainMenuUl.getBoundingClientRect().top + window.pageYOffset;
		controlTop = mainMenuTop + (mainMenuUl.offsetHeight - this._fullMenuControlElem.offsetHeight)/2;
	} else {
		controlTop = Viewport.getWidth() - this._fullMenuControlElem.getBoundingClientRect().right;
	}
	this._fullMenuControlElem.style.top = parseInt(controlTop) + 'px';
}


/**
 * @public
 */
Menu.prototype.open = function() {
	var eventOpt = EventListenerOption.get(false, true),
		eventOptNotPassive = EventListenerOption.get(false, false);
	
	window.addEventListener('keydown', this._onKeyDown, eventOptNotPassive);
	this._container.addEventListener('wheel', this._onWheel, eventOptNotPassive);
	this._container.addEventListener('click', this._onClick, eventOpt);
	
	window.addEventListener('touchstart', this._onTouchStart, eventOpt);
	window.addEventListener('touchmove', this._onTouchMove, eventOptNotPassive);
	window.addEventListener('touchend', this._onTouchEnd, eventOpt);
	
	document.body.classList.add(IS_OPEN_CLASS_NAME);
}

/**
 * @public
 */
Menu.prototype.close = function() {
	var eventOpt = EventListenerOption.get(false, true),
		eventOptNotPassive = EventListenerOption.get(false, false);
	
	window.removeEventListener('keydown', this._onKeyDown, eventOptNotPassive);
	this._container.removeEventListener('wheel', this._onWheel, eventOptNotPassive);
	this._container.removeEventListener('click', this._onClick, eventOpt);
	
	window.removeEventListener('touchstart', this._onTouchStart, eventOpt);
	window.removeEventListener('touchmove', this._onTouchMove, eventOptNotPassive);
	window.removeEventListener('touchend', this._onTouchEnd, eventOpt);
	
	document.body.classList.remove(IS_OPEN_CLASS_NAME);
}

/**
 * @public
 */
Menu.prototype.isOpen = function() {
	return document.body.classList.contains(IS_OPEN_CLASS_NAME);
}

/**
 * @public
 */
Menu.prototype.toggle = function() {
	if (document.body.classList.contains(IS_OPEN_CLASS_NAME)) {
		this.close();
	} else {
		this.open();
	}
}

module.exports = Menu;
